<template>
  <div class="civilite needResize" :class="{'fullscreen': fullscreen}" v-if="result">
    <Info @fullscreen="onFullScreen" title="civilities.title" text="civilities.info" ></Info>
    <div class="title-civilite">
      <h3>{{$t('civilities.title')}}</h3>
    </div>
    <div class="legend">
      <div v-for="(v, k) in groupedValues" :class=getClassName(k) v-if="v!=0">
        <div :class="getClassName(k, 'circle circle-')"></div><div>{{$t(`civilities.${k}`)}}</div>
      </div>
    </div>
    <div class="chart">
      <div v-for="(v, k) in groupedValues" :class="getClassName(k, 'chart-')" :style="'width:'+ rate(v) +'%'"  v-if="v>0"><span v-if="rate(v).toFixed(2) >= 1" class="text-format">{{v | splitNumber }} ({{rate(v).toFixed(2)}}%)</span></div>
    </div>
    <div class="ladder">
      <hr>
      <div class="ladder-number">
        <div v-for="i in 5">{{getLadderValue(i-1) | splitNumber}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import Info from './Info.vue'

  export default {
    name: 'Civilite',
    components: {
      Info
    },
    props: {
      result: Object
    },
    data() {
      return {
        fullscreen: false,
        ladderArray: [0, 0, 0, 0, 0],
        civilities: {
          man: {className:'man', keyLabel: 'civilities.man'},
          woman: {className:'woman', keyLabel: 'civilities.woman'},
          company: {className:'company', keyLabel: 'civilities.company'},
          other: {className:'other', keyLabel: 'civilities.other'}
        }
      }
    },
    mounted() {
    },
    methods: {
      onFullScreen() {
        this.fullscreen = !this.fullscreen
      }, 
      getClassName(c, className="") {
        return `${className}${this.civilities[c].className}`
      }, 
      rate(docCount) {
        return docCount / this.total * 100
      }, 
      getLadderValue(i) {
        return Math.round( this.total / 4 * i)
      }
    },
    computed: {
      total: function(){
        return (this.result && this.result.aggregations && this.result.aggregations.civilities) ? this.result.aggregations.civilities.buckets.reduce(((accumul, current) => accumul + current.doc_count), 0) : 0
      }, 
      groupedValues() {
        let processedResult = {
          man: 0,
          woman: 0,
          company: 0,
          other: 0
        }
        if (!this.result || !this.result.aggregations || !this.result.aggregations.civilities) return processedResult

        return this.result.aggregations.civilities.buckets.reduce((accumulator, currentValue) => {
          switch (currentValue.key) {
            case 1:
              accumulator.man = currentValue.doc_count
            break
            case 2:
            case 3:
              accumulator.woman += currentValue.doc_count
            break
            //Societe = 4              SARL = 7*/SA = 8ETS= 27EURL = 9SAS = 53
            case 4:
            case 7:
            case 8:
            case 9:
            case 27:
            case 53:
              accumulator.company += currentValue.doc_count
              break
            default:
              accumulator.other += currentValue.doc_count
          }
          return accumulator
        }, processedResult)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/civilite.sass"
</style>
